function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React from "react";
import PropTypes from "prop-types";
import { Button, Link, SkeletonText } from "@carbon/react";
import { Launch } from '@carbon/react/icons';
import Markdown from "../common/markdown.jsx";
import Notification from '../common/notification.jsx';
import msgs from "../../nls/setup/deploy/deploy.properties";
import Phase from "../common/model/phase";
import SideBar from "./side-bar.jsx";
import ToolchainHeader from "./toolchain-header.jsx";
var About = /*#__PURE__*/function (_React$Component) {
  function About() {
    _classCallCheck(this, About);
    return _callSuper(this, About, arguments);
  }
  _inherits(About, _React$Component);
  return _createClass(About, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        availableCapabilities = _this$props.availableCapabilities,
        baseName = _this$props.baseName,
        displayMode = _this$props.displayMode,
        onClickGetStarted = _this$props.onClickGetStarted,
        phase = _this$props.phase,
        showTools = _this$props.showTools,
        templateMetadata = _this$props.templateMetadata,
        wizard = _this$props.wizard;
      var locale = this.context.locale;
      var sidebar = /*#__PURE__*/React.createElement(SideBar, {
        availableCapabilities: availableCapabilities,
        baseName: baseName,
        phase: phase,
        showTools: showTools,
        template: templateMetadata
      });
      var getPreReqInfo = function getPreReqInfo() {
        if (wizard) {
          var preReq = wizard.getWelcomePreReq();
          if (preReq) {
            return /*#__PURE__*/React.createElement("div", {
              id: "welcome-pre-reqs",
              className: "textInfo"
            }, /*#__PURE__*/React.createElement(Notification, {
              kind: preReq.kind,
              lowContrast: true,
              title: "",
              format: "markdown",
              subtitle: preReq.text || ""
            }));
          }
        }
        return null;
      };
      var getDescriptionContent = function getDescriptionContent() {
        var aboutSummary;
        var docLink; // Wizard v2 only
        var docLaunchIcon; // Wizard v2 only
        var gitUrl; // Wizard v2 only
        var gitBranch; // Wizard v2 only
        var gitUrlLaunchIcon; // Wizard v2 only
        var gitBranchLaunchIcon; // Wizard v2 only
        var infoText; // Wizard v2 only
        var tutorialLink; // Wizard v2 only
        var tutorialLaunchIcon; // Wizard v2 only

        if (wizard !== null && wizard !== void 0 && wizard.isV2()) {
          aboutSummary = wizard.getDescription();
          infoText = wizard.getWelcomeInfo();
          var wizardTemplateRepo = wizard.getWelcomeTemplateRepo();
          if (wizardTemplateRepo) {
            gitUrl = "[".concat(wizardTemplateRepo.text, "](").concat(wizardTemplateRepo.url, ")");
            gitUrlLaunchIcon = /*#__PURE__*/React.createElement(Link, {
              className: "about-launch-link",
              href: wizardTemplateRepo.url,
              renderIcon: Launch,
              target: "_blank",
              rel: "noopener noreferrer"
            });
          }
          var doc = wizard.getWelcomeDocumentation();
          var tutorial = wizard.getWelcomeTutorial();
          if (doc) {
            docLink = "[".concat(doc.text, "](").concat(doc.url, ")");
            docLaunchIcon = /*#__PURE__*/React.createElement(Link, {
              className: "about-launch-link",
              href: doc.url,
              renderIcon: Launch,
              target: "_blank",
              rel: "noopener noreferrer"
            });
          }
          if (tutorial) {
            tutorialLink = "[".concat(tutorial.text, "](").concat(tutorial.url, ")");
            tutorialLaunchIcon = /*#__PURE__*/React.createElement(Link, {
              className: "about-launch-link",
              href: tutorial.url,
              renderIcon: Launch,
              target: "_blank",
              rel: "noopener noreferrer"
            });
          }
        } else if (phase !== Phase.LOADING && templateMetadata !== null && templateMetadata !== void 0 && templateMetadata.description) {
          aboutSummary = templateMetadata.description;
        }
        return /*#__PURE__*/React.createElement(React.Fragment, null, phase !== Phase.LOADING && templateMetadata && templateMetadata.description && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
          className: "side-bar__template-info-header"
        }, msgs.get("label.description")), /*#__PURE__*/React.createElement(Markdown, {
          className: "about-summary",
          content: aboutSummary
        }), (wizard === null || wizard === void 0 ? void 0 : wizard.isV2()) && displayMode === "step" && /*#__PURE__*/React.createElement(React.Fragment, null, docLink && /*#__PURE__*/React.createElement(Markdown, {
          className: "about-markdown-link",
          content: docLink,
          id: "docsLink"
        }), docLaunchIcon, docLaunchIcon && /*#__PURE__*/React.createElement("br", null), tutorialLink && /*#__PURE__*/React.createElement(Markdown, {
          className: "about-markdown-link",
          content: tutorialLink,
          id: "tutorialLink"
        }), tutorialLaunchIcon, tutorialLaunchIcon && /*#__PURE__*/React.createElement("br", null), gitUrl && /*#__PURE__*/React.createElement(Markdown, {
          className: "about-markdown-link",
          content: gitUrl,
          id: "gitUrl"
        }), gitUrlLaunchIcon, gitUrlLaunchIcon && /*#__PURE__*/React.createElement("br", null), gitBranch && /*#__PURE__*/React.createElement(Markdown, {
          className: "about-markdown-link",
          content: gitBranch,
          id: "gitBranch"
        }), gitBranchLaunchIcon, gitBranchLaunchIcon && /*#__PURE__*/React.createElement("br", null), infoText && /*#__PURE__*/React.createElement(Markdown, {
          content: infoText
        }))), phase === Phase.LOADING && /*#__PURE__*/React.createElement("div", {
          className: "skeleton-container"
        }, /*#__PURE__*/React.createElement(SkeletonText, {
          paragraph: true,
          lineCount: 5
        })), displayMode !== "step" && /*#__PURE__*/React.createElement(Button, {
          className: "get-started-btn",
          onClick: onClickGetStarted,
          "data-analytics-track": "get-started-btn-about-tab-create"
        }, msgs.get("button.get-started", locale)));
      };
      var getHeaderContent = function getHeaderContent() {
        if (templateMetadata && templateMetadata.header) {
          if (displayMode === "step") {
            return /*#__PURE__*/React.createElement(Markdown, {
              className: "about-overview-img",
              content: templateMetadata.header
            });
          }
          return /*#__PURE__*/React.createElement(ToolchainHeader, {
            key: "image",
            markdown: templateMetadata.header,
            phase: phase
          });
        }
        return null;
      };
      if (displayMode === "step") {
        return /*#__PURE__*/React.createElement("div", {
          className: "about-step"
        }, getPreReqInfo(), /*#__PURE__*/React.createElement("div", {
          "aria-label": msgs.get("template.description"),
          role: "document",
          className: "long-desc-div",
          "data-focus-first": true
        }, getDescriptionContent()), getHeaderContent());
      }

      // Sidebar with tools and git info is rendered on right-side in wizard, left in classic
      return /*#__PURE__*/React.createElement(React.Fragment, null, displayMode === "tab" && sidebar, /*#__PURE__*/React.createElement("aside", {
        "aria-label": msgs.get("template.description"),
        className: "side-bar deploy-toolchain__description",
        "data-focus-first": true
      }, getDescriptionContent()), displayMode === "side-panel" && sidebar, getHeaderContent());
    }
  }]);
}(React.Component);
export { About as default };
About.contextTypes = {
  locale: PropTypes.string,
  wizardMode: PropTypes.bool
};
About.propTypes = {
  availableCapabilities: PropTypes.array,
  baseName: PropTypes.string,
  onClickGetStarted: PropTypes.func,
  phase: PropTypes.string,
  templateMetadata: PropTypes.object
};